import { useSelector } from "react-redux";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useDrugsFileSearch = ({
  page = 1,
  rows = 30,
  searchParams = {},
} = {}) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const hasSearch = Object.values(searchParams).some(Boolean);

  return useQuery({
    queryKey: ["drugsFile", { page, rows, searchParams, tenantVal }],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const queryParams = new URLSearchParams({
        page: page.toString(),
        rows: rows.toString(),
      });

      if (searchParams.tradeName)
        queryParams.append("tradeName", searchParams.tradeName);
      if (searchParams.genericName)
        queryParams.append("genericName", searchParams.genericName);
      if (searchParams.manufacturer)
        queryParams.append("manufacturer", searchParams.manufacturer);

      const endpoint = hasSearch
        ? `${tenantVal}/drugsfile/search/paginated?${queryParams.toString()}`
        : `${tenantVal}/drugsfile/get?${queryParams.toString()}`;

      const response = await axiosInstance.get(endpoint);

      return response.data;
    },
    enabled: !!tenantVal,
    placeholderData: keepPreviousData,
  });
};
